module.exports = __webpack_public_path__ + "static/media/logo-babypage.683b1b50.png";